import { OccurrenceStepEnum } from "../../../enums/occurrenceStep";
import BudgetCreate from "../budgetCreate";
import BudgetEdit from "../budgetEdit";
import BudgetManagerEdit from "../budgetEdit/index-manager";
import BudgetDetails from "../budgetDetails";
import { BudgetOccurrenceList } from "./components/BudgetOccurrenceList";
import { useBudgetOccurrenceView } from "./hooks/useBudgetOccurrenceView";

export interface IBudgetOccurrenceViewProps {
  occurrenceId: string;
  persona: string;
  currentStep: OccurrenceStepEnum;
  onViewAttachments?: () => void;
}

const BudgetOccurrenceView = (props: IBudgetOccurrenceViewProps) => {
  const { occurrenceId, persona, currentStep } = props;

  const {
    loading,
    budgets,
    profile,
    view,
    currentBudgetId,
    currentVersion,
    goToList,
    goToCreate,
    openBudget,
  } = useBudgetOccurrenceView(occurrenceId, persona);

  if (view === "create") {
    return (
      <BudgetCreate
        persona={persona}
        fixedOccurrenceId={occurrenceId}
        onCreated={goToList}
        onClose={goToList}
        onBreadcrumbClick={goToList}
      />
    );
  }

  if (view === "edit") {
    return (
      <BudgetEdit
        persona={persona}
        budgetId={currentBudgetId}
        version={currentVersion}
        onSaved={goToList}
        onDecided={goToList}
        onClose={goToList}
        onBreadcrumbClick={goToList}
      />
    );
  }

  if (view === "edit-manager") {
    return (
      <BudgetManagerEdit
        persona={persona}
        budgetId={currentBudgetId}
        version={currentVersion}
        onSaved={goToList}
        onDecided={goToList}
        onClose={goToList}
        onBreadcrumbClick={goToList}
      />
    );
  }

  if (view === "details") {
    return (
      <BudgetDetails
        persona={persona}
        budgetId={currentBudgetId}
        version={currentVersion}
        onClose={goToList}
        onBreadcrumbClick={goToList}
      />
    );
  }

  return (
    <BudgetOccurrenceList
      budgets={budgets}
      loading={loading}
      profile={profile}
      currentStep={currentStep}
      onCreateBudget={goToCreate}
      onOpenBudget={openBudget}
    />
  );
};

export default BudgetOccurrenceView;
